import React, {
  useEffect,
  useState
} from "react";

import { Link } from "react-router-dom";

import {
  FlashSale,
  flashSaleService
} from "../pages/publicservice/flashSaleService";

const OfferSection: React.FC = () => {
 const API_PATH =
    process.env.REACT_APP_API_PATH;
  const [flashSales,
    setFlashSales] = useState<
      FlashSale[]
    >([]);

  const [loading,
    setLoading] = useState(true);

  // ==========================================
  // FETCH FLASH SALES
  // ==========================================

  useEffect(() => {

    fetchFlashSales();

  }, []);

  const fetchFlashSales =
    async () => {

      try {

        const data =
          await flashSaleService
            .getAll();

        // ONLY ACTIVE SALES
        const activeSales =
          data.filter(
            (x) => x.isActive
          );

        setFlashSales(
          activeSales
        );
      }
      catch (error) {

        console.error(
          "Error fetching flash sales:",
          error
        );
      }
      finally {

        setLoading(false);
      }
    };

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {

    return (
      <div className="text-center py-5">
        Loading...
      </div>
    );
  }


  return (
//     <section className="section-layout3 space space-extra-bottom z-index-common">
//       <img className="ele1" src="/assets/img/shapes/ele-o-1-1.svg" alt="elements" />
//       <img className="ele2" src="/assets/img/shapes/ele-o-1-2.svg" alt="elements" />
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-6 mb-30 wow animate__fadeInUp" data-wow-delay="0.2s">
//             <div className="offer-style">
//               <div className="offer-img">
//                 <img src="/assets/img/offer/offer-1-1.png" alt="offer img" />
//               </div>
//               <div className="offer-body">
//                 <span className="offer-subtitle">save up to 40% off</span>
//                 <h3 className="offer-title">
//                   <Link to="/shop">custom wedding Rings</Link>
//                 </h3>
//                 <Link to="/shop" className="vs-btn">order now</Link>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-6 mb-30 wow animate__fadeInUp" data-wow-delay="0.4s">
//             <div className="offer-style">
//               <div className="offer-img">
//                 <img src="/assets/img/offer/offer-1-2.png" alt="offer img" />
//               </div>
//               <div className="offer-body">
//                 <span className="offer-subtitle">save up to 60% off</span>
//                 <h3 className="offer-title">
//                   <Link to="/shop">custom party Rings</Link>
//                 </h3>
//                 <Link to="/shop" className="vs-btn">order now</Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

<section className="section-layout3 space space-extra-bottom z-index-common">

      <img
        className="ele1"
        src="/assets/img/shapes/ele-o-1-1.svg"
        alt="elements"
      />

      <img
        className="ele2"
        src="/assets/img/shapes/ele-o-1-2.svg"
        alt="elements"
      />

      <div className="container">

        <div className="row">

          {flashSales.length > 0 ? (

       flashSales
    .slice(0, 2)
    .map(
              (sale, index) => (

                <div
                  key={sale.flashSaleID}
                  className="col-lg-6 mb-30 wow animate__fadeInUp"
                  data-wow-delay={
                    index % 2 === 0
                      ? "0.2s"
                      : "0.4s"
                  }
                >

                  <div className="offer-style offer-style-custom">

                    <div className="offer-img">

                      <img
                        src={
                          sale.saleImageUrl
                            ? `${API_PATH}/uploads/${sale.saleImageUrl}`
                            : "/assets/img/offer/offer-1-1.png"
                        }
                        alt={sale.title}
                      />

                    </div>

                    <div className="offer-body">

                      <span className="offer-subtitle">

                        save up to {sale.saveUpTo}% off

                      </span>

                      <h3 className="offer-title">

                        <Link to="/shop">

                          {sale.title}

                        </Link>

                      </h3>

                      <Link
                        to="/shop"
                        className="vs-btn"
                      >
                        order now
                      </Link>

                    </div>

                  </div>

                </div>
              )
            )

          ) : (

            <div className="text-center">

              No flash sale found

            </div>

          )}

        </div>

      </div>

    </section>
  );
};
export default OfferSection;
